import React from 'react';
import classNames from 'classnames';
import { InputField } from '@ps-design-system/components/Input';
import { CreditCardSelectField } from './CreditCardSelectField';
import { useCheckoutContext } from '../../CheckoutContextProvider';
import { logError } from '../../services/logging-service';
import { useStripeElementsContext } from '../../StripeElementsContextProvider';

export const PaymentElement = ({ disabled, intl }) => {
  const [mounted, setMounted] = React.useState(false);
  const [showStripeElement, setShowStripeElement] = React.useState(false);

  const {
    paymentForm,
    customerPaymentMethods,
  } = useCheckoutContext();

  const { stripeElements } = useStripeElementsContext();

  const selectedCard = paymentForm.watch('selectedCreditCard');

  React.useEffect(() => {
    const isAddingNewCard = selectedCard?.id === 'new_card';
    setShowStripeElement(isAddingNewCard);
  }, [selectedCard]);

  // Initialize stripe payment elements
  React.useEffect(() => {
    if (stripeElements && !mounted) {
      try {
        const paymentElement = stripeElements?.getElement('payment')|| stripeElements.create('payment', {
          terms: {
            card: 'never'
          },
          wallets: {
            googlePay: 'never',
            applePay: 'never'
          }
        });
        paymentElement.mount('#payment-element');
        setMounted(true);
      } catch (e) {
        logError('stripe.createPaymentElement', e);
      }
    }
  }, [stripeElements, mounted]);

  return (
    <div className="flex column tw-gap-16">
      <CreditCardSelectField
        form={paymentForm}
        name="selectedCreditCard"
        customerPaymentMethods={customerPaymentMethods}
        disabled={disabled}
        fullWidth
      />

      <div
        className={classNames('flex column tw-gap-16', {
          hidden: !showStripeElement
        })}
      >
        <InputField
          label={intl.formatMessage({
            id: 'payment_form.cardholders_name',
            defaultMessage: 'Cardholder’s name'
          })}
          testId="cardholder-name-input"
          formControl={paymentForm.control}
          name="cardholderName"
          placeholder={intl.formatMessage({
            id: 'payment_form.first_last',
            defaultMessage: 'First Last'
          })}
          fullWidth
        />
        <div id="payment-element" />
      </div>
    </div>
  );
};
